<template>
  <!--pageLoadingComplete 页面加载完毕判定-->
  <div class="container-wrapper" :class="is_buy ? 'container-buy' : ''">
    <template v-if="pageLoadingComplete">
      <!-- 已购买 -->
      <div class="goods-infor" v-if="is_buy">
        <div class="goods-card container">
          <GoodsInfoTitle :title="goodInforTitle" />

          <!--已购买 商品信息-->
          <div class="goods-card-content" v-if="!offlineProduct">
            <!--规格展示-->
            <div class="goods-specs">
              <div class="goods-specs-item">
                <div class="name" style="width: 100%" v-if="goodsData.usability == 'free'">
                  有效期:永久
                </div>
                <div class="name" style="width: 100%" v-else-if="goodsData.buy_expiry">
                  有效期至{{ goodsData.buy_expiry }}
                </div>
              </div>
            </div>

            <!--题集以外的商品-->
            <template>
              <div class="question-count course-count" v-if="isShowGoodsQQ || goodsData.intro">
                <p class="question-count-item course-count-item">
                  <a class="text" :href="goodsData.intro_url" v-if="goodsData.intro_url">
                    <img :src="getCurrentBrand.imageGoodsTitleButtonText" class="icon" />
                    介绍
                  </a>
                  <a :href="goodsData.qq.value.qqLink" class="text" v-if="isShowGoodsQQ">
                    <img :src="getCurrentBrand.imageGoodsTitleButtonQQ" class="icon" />
                    Q群
                  </a>

                  <a v-if="goodsData.guide_content"
                    href="https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/title_button_wx.png"
                    class="text">
                    <img :src="getCurrentBrand.imageGoodsTitleButtonQQ" class="icon" />
                    {{ goodsData.guide_content.icon_title }}
                  </a>
                </p>
              </div>
            </template>

            <!-- 班级群 -->
            <div class="teacher-group" v-if="goodsData.class_group">
              <img
                src="https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/qq_qun.png"
                class="icon" />
              <p class="text">{{ goodsData.class_group.title }}</p>
              <a :href="goodsData.class_group.content.qqLink" class="button">
                {{ goodsData.class_group.btn_title }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 未购买 -->
      <div class="goods-infor" v-else>
        <div class="goods-card container">
          <GoodsInfoTitle :title="goodInforTitle" :prefixText="goodsData.prefix_text" />
          <!-- <Goods-infor-cell-price :goodsData="goodsData" :unitName="unitName" :currentSpecs="currentSpecs"
                    :productCase="productCase" :offlineProduct="offlineProduct" :titleObj="titleObj"/> -->
          <GoodsInforLabels :labels="goodsData.tags" v-if="goodsData.tags" />
          <GoodsInfoCellSpecs :nameMaxLength="goodsCourseDescMaxLength"
            v-if="goodsData.usability !== 'free' && goodsData.usability !== 'identity'" :productCase="productCase"
            :currentSpecs="currentSpecs" @clickSpecs="specsTriggerAction()" />
        </div>
      </div>

      <!-- 自定义描述 只有未购买时显示-->
      <div class="goods-infor" style="border-top: 0.21rem solid #f7f8fa"
        v-if="goodsData.course_desc && goodsData.course_desc.list.length && !is_buy">
        <div class="goods-card2 container">
          <GoodsInfoCellItem :nameMaxLength="goodsCourseDescMaxLength" :name="item.item" :text="item.content"
            v-for="(item, index) in goodsData.course_desc.list" :key="index" />
          <div class="coupon-box" v-if="goodsData.coupon">
            <div class="name">领劵</div>
            <div class="coupon-list">
              <div class="coupon-item" v-for="(item, index) in goodsData.coupon" :key="index">
                <div class="left">{{ item.name }}</div>
                <img src="@/assets/images/goods/coupon.png" />
                <div class="right">APP内领取</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="goods-content">
        <van-tabs v-model="tabsActiveIndex" :scrollspy="!is_buy" sticky class="jbc-tabs"
          :class="tabsList.length <= 1 ? 'hideTabNav' : ''">
          <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
            <!-- 商品目录 -->
            <!-- 已购买 -->
            <template v-if="is_buy">
              <div class="goods-catalog">
                <div class="container">
                  <GoodsLiveTips @onButton="onGoodsLiveClick" :liveInfor="currentLiveInfor"
                    :liveStatus="currentLiveInfor.live_status" v-if="currentLiveInfor && item.listKey === 'live'" />
                  <CatalogList :list="item.list" :type="item.listKey" :isBuy="is_buy"
                    @onCatalogLive="onGoodsLiveClick" />
                </div>
              </div>
            </template>

            <!-- 未购买 -->
            <template v-else>
              <!-- 课程表相关 -->
              <template v-if="item.listKey === 'course_list'">
                <!-- 直播课程 -->
                <div class="goods-catalog" v-if="goodsData.live_list.length">
                  <div class="container">
                    <div class="header">
                      <span class="title">直播课程</span>
                      <span class="subtitle">{{ goodsData.live_list.length }}个</span>
                    </div>
                    <CatalogList :list="goodsData.live_list" type="live" :isBuy="is_buy" />
                  </div>
                </div>

                <!-- 录播课程 -->
                <div class="goods-catalog" v-if="goodsData.vod_list.length">
                  <div class="container">
                    <div class="header">
                      <span class="title">录播课程</span>
                      <span class="subtitle">{{ goodsData.vod_list.length }}个</span>
                    </div>
                    <CatalogList :list="goodsData.vod_list" type="vod" :isBuy="is_buy" />
                  </div>
                </div>
              </template>

              <!-- 非课程表 -->
              <template v-else>
                <div class="goods-catalog">
                  <div class="container">
                    <div class="header" v-if="item.listKey === 'teacher'">
                      <span class="title">授课老师</span>
                    </div>
                    <div class="header" v-else-if="item.listKey !== 'intro'">
                      <span class="title">{{ item.name }}</span>
                      <span class="subtitle">{{ item.list.length }}个</span>
                    </div>

                    <!-- 介绍页 -->
                    <div class="container-row" v-if="item.listKey == 'intro'">
                      <div v-html="bodyInfo(item.list)" class="imgBox"></div>
                    </div>

                    <!-- 老师板块 -->
                    <div class="catalog-teacher-list" v-else-if="item.listKey == 'teacher'">
                      <TeacherList :list="item.list" />
                    </div>
                    <CatalogList v-else :list="item.list" :type="item.listKey" :isBuy="is_buy" />
                  </div>
                </div>
              </template>
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </template>

    <!--商品规格选择-->
    <van-action-sheet v-model="isSpecsAction" title="规格选择" :closeable="false" class="specs-action container">
      <SpecsAction :list="productCase.case" @confirmClick="specsTriggerAction" @change="changeSpecsItem"
        :isVipPricePower="isVipPricePower" />
    </van-action-sheet>

    <!-- 侧边打开APP悬浮按钮(停售且未购买时不显示) -->
    <SideOpenApp unitKey="CourseDetail" :options="{ no: goodsData.no }" v-if="goodsData.status !== 5" />

    <!-- 打开app方法调用 -->
    <FooterOpenApp ref="footer_open_app" :name="getCurrentBrand.name" schemaUnitKey="CourseDetail"
      style="display: none" />

    <!-- 底部按钮价格 -->
    <GoodsButtonPrice v-if="!is_buy" :goodsData="goodsData" :unitName="unitName" :currentSpecs="currentSpecs"
      :productCase="productCase" :offlineProduct="offlineProduct" :titleObj="titleObj">
      <a v-if="goodsCustomerUrl" class="kefu" :href="goodsCustomerUrl">
        <img src="@/assets/images/goods/kefu.png" class="icon" />
        <p class="text">客服</p>
      </a>

      <!-- 已购买 -->
      <template v-if="is_buy">
        <van-button round type="primary" class="open-button" :disabled="true">已购买</van-button>
      </template>

      <!-- 未购买 -->
      <template v-else>
        <!-- 该课程已停售 -->
        <template v-if="goodsData.status === 5">
          <van-button :disabled="true" round type="primary" class="open-button">已停售</van-button>
        </template>

        <!-- 会员商品 -->
        <template v-else-if="isVipGoods">
          <!-- 免费领取 -->
          <van-button v-if="isFreeVipBuy" round type="primary" class="open-button" @click="buy">
            立即购买
          </van-button>

          <!-- 提示开通 -->
          <FooterOpenApp v-else :name="getCurrentBrand.name" :logoImage="getCurrentBrand.imageLogoURL" text="开通会员"
            :schemaUnitKey="currentUnit.schemaUnitKey" buttonText="开通" />
        </template>

        <!-- 非会员商品 -->
        <template v-else>
          <!-- 免费课程 -->
          <van-button v-if="goodsData.usability == 'free'" round type="primary" class="open-button" @click="buy">
            添加课程
          </van-button>
          <!-- 功能包 -->
          <van-button v-else-if="goodsData.usability == 'identity'" round type="primary" class="open-button"
            @click="buy">
            查看
          </van-button>
          <!-- 普通课程 -->
          <van-button v-else-if="showWxBuyButton" round type="primary" class="open-button" @click="buy">
            立即购买
          </van-button>
        </template>
      </template>
    </GoodsButtonPrice>

    <!--=================线下商品========================-->
    <van-action-sheet v-model="showAction" :closeable="false" :close="closeChange">
      <div class="actionContent">
        <p class="actionTitle">{{ titleObj.title }}</p>
        <p class="actionPriceMap">
          <span class="symbol">￥</span>
          {{ titleObj.starPrice }}
          <span class="line" v-if="titleObj.starPrice < titleObj.endPrice">-</span>
          {{ titleObj.starPrice < titleObj.endPrice ? titleObj.endPrice : '' }} </p>
            <div class="typeMap">
              <template v-if="
                offlineProduct && offlineProduct.group_list && offlineProduct.group_list.length > 0
              ">
                <div class="typeList" v-for="(item, index) in offlineProduct.group_list" :key="index + 'group_list'">
                  <p class="typeTitle">{{ item.name }}</p>
                  <template v-if="item.option_list && item.option_list.length > 0">
                    <div :class="{
                      typeContent: true,
                      typeContentNoWrap: offlineProduct.group_list.length == 1,
                    }">
                      <!--typeContentNoWrap 垂直摆放样式-->
                      <p v-for="(childItem, childIndex) in item.option_list" :key="childIndex + 'childIndex'">
                        <span @click="typeClick(index, childItem.no, childItem.disableShow)" :class="{
                          typeItem: true,
                          typeItemActive: childItem.isActive,
                          typeItemDisable: childItem.disableShow,
                        }">
                          {{ childItem.name }}
                        </span>
                      </p>
                    </div>
                  </template>
                </div>
              </template>
            </div>

            <!--购买按钮-->
            <FooterButtonBuy :buttonText="showModelOnes ? '去支付' : '确定'" :isDisable="isDisableButton"
              :customerInfoURL="goodsCustomerUrl" @clickButton="analyzingConditions" />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import CatalogList from '@/components/Goods/CatalogList'
import SpecsAction from '@/components/Goods/SpecsAction'
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import GoodsDetailInfo from '@/components/Goods/GoodsDetailInfo.vue'
import FooterButtonBuy from '@/components/FooterButtonBuy'

import { getCourseDetail } from '@/api/goods/detail'
import { addFreeVirtualGoods } from '@/api/order'
import mixinGoodsOffline from '@/views/goods/mixins/goodsOffline'
import mixinGoodsCommon from '@/views/goods/mixins/goodsCommon'
import mixinDeviceToPc from '@/views/goods/mixins/deviceToPc'

import GoodsInfoTitle from '@/components/GoodsInfo/GoodsInfoTitle.vue'
import GoodsInfoCell from '@/components/GoodsInfo/GoodsInfoCellItem.vue'
import GoodsInfoCellPrice from '@/components/GoodsInfo/GoodsInfoCellPrice.vue'
import GoodsInfoCellSpecs from '@/components/GoodsInfo/GoodsInfoCellSpecs.vue'
import GoodsInfoCellItem from '@/components/GoodsInfo/GoodsInfoCellItem.vue'
import GoodsInforLabels from '@/components/GoodsInfo/GoodsInfoLabels.vue'
import GoodsButtonPrice from '@/components/Goods/GoodsButtonPrice.vue'
import SideOpenApp from '@/components/SideOpenApp.vue'
import TeacherList from '@/components/Goods/TeacherList.vue'
import GoodsLiveTips from '@/components/Goods/GoodsLiveTips.vue'
import { isWXBrowser } from '@/utils/browser'
export default {
  name: 'CourseDetail',
  components: {
    FooterButtonBuy,
    CatalogList,
    SpecsAction,
    FooterOpenApp,
    GoodsDetailInfo,
    GoodsInfoTitle,
    GoodsInfoCell,
    GoodsInfoCellPrice,
    GoodsInfoCellSpecs,
    GoodsInfoCellItem,
    GoodsInforLabels,
    GoodsButtonPrice,
    SideOpenApp,
    TeacherList,
    GoodsLiveTips,
  },
  mixins: [mixinGoodsOffline, mixinGoodsCommon, mixinDeviceToPc],
  data() {
    return {
      goodsThreePoint: this.$imageURL.goodsThreePoint,
      isSpecsAction: false, //是否显示勾选规格按钮

      // 单元名称 course
      unitName: 'course',
      unitNameList: {
        // 课程
        course: {
          request: getCourseDetail,
          schemaUnitKey: 'CourseDetail',
          goodsAddRequestType: 'course',
          recommendType: 'course',
          openAppText: '开始学习',
          title: '：精品课程分享',
          freeButtonText: '添加课程',
        },
      },

      goodsData: {}, // 商品数据

      tabsList: [], // tab列表数据
      tabsActiveIndex: 0, //tab选中下标

      // 商品规格
      productCase: { case: [] },
      pageLoadingComplete: false,
      isMultipleSpecsOnceSelect: false, //多规格商品是否选中过一次

      // 是否禁用按钮
      isDisableButton: false,

      // 是否购买
      is_buy: false,

      showWxBuyButton: true,
    }
  },

  computed: {
    // 当前单元
    currentUnit() {
      return this.unitNameList[this.unitName]
    },
    // 当前规格
    currentSpecs() {
      let caselist = this.productCase.case || []
      let result = caselist.filter((item) => {
        return item.default === 1
      })
      return result[0]
    },
    // 是否是多规格
    isMultipleSpecs() {
      return this.productCase.case.length > 1
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return !!this.goodsData.is_membership_price
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    // 按钮文案
    buttonText() {
      return this.isFreeGoods ? this.currentUnit.freeButtonText : '立即购买'
    },
    // 商品客服链接
    goodsCustomerUrl() {
      // 先取出客服列表 & 客户信息（避免重复?.）
      const serviceList = this.goodsData?.customer_service || []
      const customerInfo = this.goodsData?.customer_info

      // 优先取客服第一条，没有则取客户信息里的url
      return serviceList.length > 0
        ? serviceList[0].value
        : customerInfo?.url
    },
    // 商品标题
    goodInforTitle() {
      if (this.offlineProduct && this.offlineProduct.case_type == 'group') {
        return this.titleObj.title
      } else {
        return this.goodsData.name
      }
    },
    isShowGoodsQQ() {
      return this.goodsData?.qq && this.goodsData.qq.length > 0
    },
    // 当前直播信息
    currentLiveInfor() {
      let result = null
      this.goodsData.live_list.forEach((item, index) => {
        if (index >= 4 && !result) {
          item.live_status === 0
          result = item
        }
        if (item.live_status === 1) {
          result = item
        }
      })
      return result
    },
    goodsCourseDescMaxLength() {
      let max = 2
      if (!this.goodsData.course_desc) {
        return max
      }
      this.goodsData.course_desc.list.map((item) => {
        if (item.item.length > max) {
          max = item.item.length
        }
      })

      return max
    },
  },
  created() {
    document.title = this.getCurrentBrand.name + this.currentUnit.title
    this.checkURLBuyState()
    this.getGoodsDetail()
    this.checkIsAPP()
    // const that = this
    // // 添加一个事件监听器来监听页面可见性的变化
    // document.addEventListener("visibilitychange", function () {
    //     if (document.visibilityState === "visible") {
    //         that.getGoodsDetail()
    //     } else {

    //     }
    // });
    this.setupRecommendCode(this.$route.query, {
      rcode_range: this.currentUnit.recommendType,
    })
  },

  methods: {
    //判断是否是app
    checkIsAPP() {
      if (window?.tikuWeb?.setShareHtml) {
        this.openApps()
        setTimeout(() => {
          window.history.back()
        }, 1500)
        return true
      }
      if (window?.webkit?.messageHandlers?.canLoadShare) {
        this.openApps()
        setTimeout(() => {
          window.close()
        }, 1500)
        return true
      }
      return false
    },
    // 打开app
    openApps() {
      // 会员时保留当前购买状态（APP内不更改状态）
      if (!this.isVipGoods && !window?.webkit?.messageHandlers?.canLoadShare) {
        this.is_buy = true
      }
      this.pageLoadingComplete = true
      setTimeout(() => {
        this.$refs.footer_open_app.openApp()
      })
    },
    // 获取商品详情
    getGoodsDetail() {
      let requestGoods = this.currentUnit.request,
        params = this.routeFixedParam()

      params.no = this.$route.query.no
      // 商品请求
      requestGoods({ ...params }).then((res) => {
        if (res.status == 1 || res.status == 6001) {
          // 页面加载完成
          this.pageLoadingComplete = true

          let resData = res.data || {}
          let product = resData.product || {}

          // 当页面状态是未购买的时  刷新购买状态
          if (!this.is_buy) {
            this.updateGoodsBuySate(resData.is_buy)
          }
          /*============================= start 线下商品======================*/
          if (product.case_type == 'group') {
            this.offlineProduct = product
            this.getCopyTitle(product.case)
            this.copyTitleObj['title'] = product.name
            this.titleObj['title'] = product.name
            this.disableUpdate()
          }
          /*============================= end 线下商品======================*/
          // 初始化商品规格数据
          this.updateGoodsProduct(product)
          // 格式化商品数据
          this.dataGoodsFormatMiddle(resData)
          // 获取老师列表
          this.getTeacherDetail(resData.teacher)
          this.setShareCard()
          // 跳转登录
        } else {
          this.$router.replace({
            name: 'emptyContent',
            query: { url: this.$route.fullPath },
          })
        }
      })
    },

    // 设置分享卡片
    setShareCard() {
      const shareOpiton = this.goodsData?.share || {}
      console.log(shareOpiton)
      this.$util.setShare({
        title: shareOpiton.title || '',
        desc: shareOpiton.desc || '',
        link: window.location.href,
        imgUrl: shareOpiton.image || '',
      })
    },

    // 商品数据格式化 中间件
    dataGoodsFormatMiddle(data) {
      let dataGoods = {}
      dataGoods = data
      this.dataGoodsFormat(dataGoods)
    },
    tabsListFactory(dataKeyName, name, listKey) {
      return { dataKeyName, name, listKey }
    },
    // 商品数据格式化
    dataGoodsFormat(sourceData) {
      let tabsListFactory = this.tabsListFactory,
        data = sourceData,
        tabsList = [],
        contentList = [tabsListFactory('intro', '课程介绍', 'intro')]
      if (this.is_buy) {
        contentList.push(tabsListFactory('live_list', '直播课', 'live'))
        contentList.push(tabsListFactory('vod_list', '录播课', 'vod'))
      } else {
        contentList.push(tabsListFactory('no', '课程表', 'course_list'))
        contentList.push(tabsListFactory('teacher_list', '老师简介', 'teacher'))
      }

      contentList.push(tabsListFactory('qv_list', '习题单', 'qv'))
      contentList.push(tabsListFactory('material_list', '资料', 'material'))
      contentList.push(tabsListFactory('course', '课程', 'identity'))
      contentList.push(tabsListFactory('question_set', '题集', 'identity'))

      if (this.is_buy) {
        contentList.shift()
      }
      contentList.forEach(function (item) {
        let list = data[item.dataKeyName]
        if (list && list.length > 0) {
          tabsList.push({
            name: item.name,
            listKey: item.listKey,
            list: list,
          })
        }
      })
      this.tabsList = tabsList
      console.log(this.tabsList, '---')
      this.goodsData = data
    },

    // 触发规格勾选
    specsTriggerAction() {
      this.isSpecsAction = !this.isSpecsAction
      this.isMultipleSpecsOnceSelect = true
    },
    // 更改规格
    changeSpecsItem(list) {
      this.productCase.case = list
    },

    // 检查url 购买状态
    checkURLBuyState() {
      if (this.$route.query.buyState !== undefined) {
        // 更新购买状态 已购买
        this.updateGoodsBuySate(true)
      }
    },

    // 添加免费商品
    addFreeGoods() {
      let param = this.routeFixedParam()
      param.item_no = this.$route.query.no
      param.pay_type = 'free'
      if (this.currentUnit.goodsAddRequestType) {
        param.type = this.currentUnit.goodsAddRequestType
      }

      if (this.isFreeVipBuy) {
        param.pay_type = 'membership'
      }

      addFreeVirtualGoods(param).then((res) => {
        // 添加成功
        if (res.status === 1) {
          this.$toast('添加成功')
          this.getGoodsDetail()
          return
        }
        this.$toast(res.message)
      })
    },

    // 检查是否为免费商品
    checkFreeGoods() {
      // 免费课程直接添加
      if (this.isFreeGoods) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为会员免费购买商品
    checkVipFreeBuyGoods() {
      if (this.isFreeVipBuy) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为身份商品
    checkUsabilityGoods() {
      let query = this.routeFixedParam()

      // 课程类型为身份时，跳转身份详情页
      if (this.goodsData.usability === 'identity') {
        query.no = this.goodsData.identity.no
        this.$router.push({
          path: '/identity/detail',
          query,
        })
        return true
      }
    },

    // 点击购买时执行的方法
    buy() {
      if (this.checkIsAPP()) {
        return false
      }
      if (this.checkUserNotLogin()) {
        return false
      }
      if (this.checkFreeGoods()) {
        return false
      }
      if (this.checkVipFreeBuyGoods()) {
        return false
      }
      if (this.checkUsabilityGoods()) {
        return false
      }
      // 线下课程
      if (this.offlineProduct?.case_type == 'group' && this.offlineProduct.group_list.length > 0) {
        this.showAction = true
        return false
      }
      // 多规格未选择时，需选择一次
      // if (!this.isMultipleSpecsOnceSelect && this.isMultipleSpecs) {
      //     this.specsTriggerAction()
      //     return false
      // }
      let o = {}
      o.product_no = this.productCase?.no
      o.case_id = this.currentSpecs.id
      o.count = 1
      this.goPay([o])
    },
    // 直播中按钮点击
    onGoodsLiveClick(liveInfor) {
      if (liveInfor.live_status === 0) {
        this.$toast('直播未开始')
        return false
      }
      if (liveInfor.live_status === 2) {
        this.$toast('直播已结束')
        return false
      }
      if (liveInfor.live_status === 3) {
        this.$toast('请前往APP观看回放课程')
        return false
      }

      const query = this.routeFixedParam()
      query.course_no = this.$route.query.no
      query.id = liveInfor.id
      this.$router.push({
        path: '/live/play',
        query,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$mainColor: var(--main-color);

/deep/ .hideTabNav {
  .van-tabs__wrap {
    display: none !important;
  }
}

/deep/ .van-tabs__nav {
  padding: 0 0.53rem;
}

.goods {
  &-card {
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;

    &+& {
      border-top: 0.01rem solid #f7f8fa;
    }

    &-title {
      font-size: 0.48rem;
      line-height: 0.8rem;
      color: $color_black;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }
  }

  &-catalog {
    border-bottom: 0.2rem solid #f7f8fa;
    background: #fff;

    .header {
      padding-top: 0.5rem;
      margin-bottom: -0.1rem;

      .title {
        font-size: 0.4rem;
        font-weight: bold;
      }

      .subtitle {
        font-size: 0.32rem;
        color: #919499;
        margin-left: 0.2rem;
      }
    }

    .image {
      display: block;
      width: 100%;
    }
  }
}

.van-tab__pane {
  &:nth-last-child(1) {
    min-height: 90vh;
    background-color: #fff;
  }
}

.van-tab__pane:nth-last-child(1) {
  .goods-catalog {
    border: none;
  }
}

.container-buy {
  .goods-catalog {
    border: none;
  }
}

.specs-action {
  padding-bottom: 0.6rem;

  .van-action-sheet__header {
    padding: 0.59rem 0;
    font-size: 0.48rem;
    line-height: 1;
    color: #18191a;
    text-align: left;
    font-weight: bold;
  }
}

.course-count {
  &-item {
    .text {
      line-height: 0.37rem;
      font-size: 0.32rem;
      color: #666666;

      .icon {
        display: inline-block;
        width: 0.37rem;
        transform: translateY(0.05rem);
        margin-right: 0.2rem;
      }

      &+.text {
        margin-left: 0.5rem;
      }
    }
  }
}

/deep/ .van-sticky.van-sticky--fixed {
  @include maxWidth();
}

.buy-button {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.65rem;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top: 0.01rem solid #eee;
  background-color: #fff;
  @include maxWidth();

  .kefu {
    .icon {
      width: 0.53rem;
      margin-left: 0.05rem;
    }

    width: 1.7rem;
    height: 1rem;
  }
}

/deep/ .jbc-tabs {
  border-top: 0.21rem solid #f7f8fa;

  .van-tabs__wrap {
    height: 1.6rem;

    .van-tabs__nav {
      // padding-top: 0.1rem;
      padding-bottom: 0;
      box-sizing: border-box;
    }
  }

  .van-tabs__line {
    bottom: 0.2rem;
  }
}

.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;

  &.container-buy {
    .van-tab__pane {
      &:nth-last-child(1) {
        min-height: auto;
      }
    }
  }
}

/deep/ .imgBox img {
  max-width: 100%;
}

/*线下课程弹窗*/
.actionContent {
  padding: 0.53rem 0.53rem 1.8rem;
  min-height: 1.65rem;
  overflow: hidden;

  .actionTitle {
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.66rem;
    color: #18191a;
    letter-spacing: 5.843277962457472 e-15px;
  }

  .actionPriceMap {
    margin-top: 0.21rem;
    padding-bottom: 0.56rem;
    border-bottom: 0.01rem solid #ebecf0;
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.59rem;
    color: #ff6a4d;
    letter-spacing: 5.843277962457472 e-15px;

    .symbol {
      font-size: 16px;
      /*font-weight: 500;*/
    }

    .line {
      margin: 0 4px;
    }
  }

  .typeMap {
    width: 100%;
    max-height: 8.36rem;
    /*margin-top: 0.43rem;*/
    padding-top: 0.43rem;
    overflow-y: scroll;

    .typeList {
      width: 100%;
      margin-bottom: 0.56rem;

      .typeTitle {
        font-size: 0.37rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: #22242e;
        letter-spacing: 5.843277962457472 e-15px;
        margin-bottom: 0.42rem;
        font-family: PingFang SC;
      }

      .typeContent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .typeItem {
          display: inline-block;
          font-size: 0.35rem;
          font-weight: 400;
          padding: 0.16rem 0.32rem;
          background: #f7f8fa;
          font-family: PingFang SC;
          border-radius: 0.11rem;
          border: 1px solid #f7f8fa;
          margin: 0 0.32rem 0.42rem 0;
          color: #3c3d42;
        }

        .typeItemActive {
          z-index: 1;
          position: relative;
          border-color: $mainColor;
          color: $mainColor;

          &:after {
            z-index: -1;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $mainColor;
            opacity: 0.05;
          }
        }

        .typeItemDisable {
          background-color: #f7f8fa;
          border-color: #f7f8fa;
          color: #c2c5cc;
        }
      }

      .typeContentNoWrap {
        flex-direction: column;

        .typeItem {
          width: auto;
          display: inline-block;
        }
      }
    }
  }
}

.goods {
  &-card {
    padding-top: 0.2rem;
    padding-bottom: 0.4rem;

    &+& {
      border-top: 0.01rem solid #f7f8fa;
    }

    &2 {
      padding-top: 0.4rem;
      padding-bottom: 0.4rem;
    }
  }
}

.kefu {
  .icon {
    width: 0.53rem;
    margin-left: 0.05rem;
  }

  width: 1.7rem;
  height: 1rem;
}

.catalog-teacher-list {
  /deep/ .teacher-list {
    white-space: initial;

    li {
      padding: 0.53rem 0;

      &+li {
        border-top: 0.01rem solid #ebecf0;
      }
    }

    .portrait {
      width: 1.28rem;
      height: 1.28rem;
      margin-right: 0.32rem;
    }

    .name {
      font-size: 0.37rem;
      font-weight: 500;
      color: #3c3d42;
      margin-top: 0.15rem;
    }

    .title {
      font-size: 0.29rem;
      font-weight: 400;
      color: #919499;
    }
  }
}

.goods {
  &-specs {
    &-item {
      display: flex;
      padding: 0.2rem 0;

      .name {
        height: 0.43rem;
        font-size: 0.29rem;
        font-weight: 400;
        color: #c2c5cc;
      }
    }
  }
}

.question-count {
  display: flex;
  margin-bottom: 0.2rem;

  &-item {
    font-size: 0.37rem;
    line-height: 0.35rem;
    color: #919499;
    padding: 0 0.2rem;
    margin-top: 0.4rem;

    &:nth-child(1) {
      padding-left: 0;
    }

    &+& {
      border-left: 1px solid #919499;
    }

    .number {
      font-size: 0.45rem;
      color: #18191a;
      font-weight: bold;
    }
  }
}

.teacher-group {
  display: flex;
  align-items: center;
  height: 0.75rem;
  border-top: 0.01rem solid #ebecf0;
  padding-top: 0.32rem;
  margin-top: 0.6rem;

  .icon {
    width: 0.75rem;
    height: 0.75rem;
    margin-right: 0.2rem;
  }

  .text {
    @include ellipsis;
    width: 5rem;
    font-size: 0.29rem;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0.48rem;
    color: #666666;
  }

  .button {
    @include flex_center;
    margin-left: auto;
    width: 2.11rem;
    height: 0.64rem;
    background: rgba(var(--main-rgba), 0.05);
    border: 1px solid rgba(var(--main-rgba), 0.5961);
    border-radius: 0.53rem;
    color: var(--main-color);
    font-size: 0.29rem;
  }
}

.coupon-box {
  display: flex;
  padding: 0.14rem 0;

  .name {
    width: 1.92rem;
    font-size: 0.32rem;
    color: #919499;
    line-height: 0.48rem;
  }

  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    .coupon-item {
      display: flex;
      margin-right: 0.23rem;
      margin-bottom: 0.23rem;

      .left {
        color: #ff6a4d;
        font-size: 0.29rem;
        background: rgba(255, 106, 77, 0.05);
        border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
        opacity: 1;
        border: 0.01rem solid rgba(255, 106, 77, 0.3);
        padding: 0.06rem 0.11rem;
        border-right: 0;
      }

      .right {
        color: rgba(255, 106, 77, 0.5);
        font-size: 0.29rem;
        background: rgba(255, 106, 77, 0.05);
        border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
        opacity: 1;
        border: 0.01rem solid rgba(255, 106, 77, 0.3);
        padding: 0.06rem 0.11rem;
        border-left: 0;
      }
    }
  }
}
</style>
